import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template as ComparisonMatrixTemplate } from "../../../components/comparison-matrix/comparison-matrix.templates";

const Template = ({ firstColumnWidth }) => html`
    <div class="ux-t-container ux-u-mb-fluid-s">
        ${ComparisonMatrixTemplate({ firstColumnWidth })}
    </div>
`;

export default {
    title: "Website/Partial Templates/Compatibility Matrix",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        firstColumnWidth: {
            control: {
                type: "number",
            },
        },
    },
    args: {
        firstColumnWidth: 180,
    },
};

export const Default = {};
